import React, { useRef } from 'react'
import { Container, Box, Grid, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import SchoolIndexHelmet from 'helmets/SchoolIndexHelmet'
import { useStyles } from './SchoolIndex_style'
import CTADashboard from 'components/CTADashboard/CTADashboard'
import ProgressCircle from 'components/ProgressCircle/ProgressCircle'
import SchoolCard from 'cards/SchoolCard/SchoolCard'
import FiltersViewWrapper from 'components/FiltersViewWrapper/FiltersViewWrapper'
import SchoolVideos from './components/SchoolVideos/SchoolVideos'
import SchoolNews from './components/SchoolNews/SchoolNews'
import SchoolProgramNews from './components/SchoolProgramNews/SchoolProgramNews'
import SchoolIndexHalfPageArticles from './components/SchoolIndexHalfPageArticles/SchoolIndexHalfPageArticles'
import SchoolIndexChips from './components/SchoolIndexChips/SchoolIndexChips'
import FeaturedSchoolFilters from 'components/Searchbar/FeaturedSchoolFilters/FeaturedSchoolFilters'
import { SCHOOL_INDEX_HALF_PAGE } from 'assets/AlertsHelper'
import CTAAlert from 'components/CTAAlert/CTAAlert'
import Button from 'shared/components/Button/Button.jsx'

const SchoolIndexView = (props) => {
    const classes = useStyles()
    const schoolsRef = useRef()
    const videoRef = useRef()
    const newsRef = useRef()
    const programNewsRef = useRef()
    const { user, schools, loading, loadMoreStatus, showMoreOnClick, filterSchools, filters, setFilters, urlFilters, schoolCount, searchableCityList } = props

    return (
        <>
            <SchoolIndexHelmet/>
            <Box className={classes.pageContent}>
                <FiltersViewWrapper titleId='school_index.title'/>
                <Container maxWidth='lg'>
                    <Box className={classes.upperSectionBox}>
                        <Box className={classes.schoolIndexChipsBox}>
                            <SchoolIndexChips
                                schoolsRef={schoolsRef}
                                videoRef={videoRef}
                                newsRef={newsRef}
                                programNewsRef={programNewsRef}
                            />
                        </Box>
                        <Box className={classes.mainBox}>
                            <Box className={classes.leftBox}>
                                <Grid container spacing={2} ref={schoolsRef}>
                                    <Grid item xs={12}>
                                        <Typography variant='h6' component='p' className={classes.subTitle}>
                                            <FormattedMessage id='school_index.sub_title' />
                                        </Typography>
                                        <FeaturedSchoolFilters
                                            searchableCityList={searchableCityList}
                                            user={user}
                                            handleFilterChange={filterSchools}
                                            filters={filters || {}}
                                            setFilters={setFilters}
                                            urlFilters={urlFilters}
                                            schoolCount={schoolCount}
                                        />
                                    </Grid>
                                    {schools.map(school => {
                                        return (
                                            <Grid key={school.id} item xs={12} sm={6}>
                                                <SchoolCard school={school} />
                                            </Grid>
                                        )
                                    })}
                                    {loading && <ProgressCircle/>}
                                    {!loading && loadMoreStatus &&
                                        <Grid item xs={12}>
                                            <Box className={classes.showMoreButtonBox}>
                                                <Button size='small' onClick={showMoreOnClick} className={classes.showMoreButton}>
                                                    <FormattedMessage id='item_index.show_more_button' />
                                                </Button>
                                            </Box>
                                        </Grid>
                                    }
                                    {!loading && schools.length === 0 &&
                                        <Box mt={4} mb={8}>
                                            <Typography variant='body2'>
                                                <FormattedMessage id='item_index.no_found_offer' />
                                            </Typography>
                                        </Box>
                                    }
                                </Grid>
                            </Box>
                            <Box className={classes.rightBox}>
                                <Box className={classes.articleBox}>
                                    <SchoolIndexHalfPageArticles key='recent-articles-education'/>
                                </Box>
                                <CTAAlert
                                    type='student_job'
                                    user={user}
                                    componentType='default'
                                    origin={SCHOOL_INDEX_HALF_PAGE}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <Box className={classes.sectionBox} ref={videoRef}>
                        <SchoolVideos user={user}/>
                    </Box>
                    <Box className={classes.sectionBox} ref={newsRef}>
                        <SchoolNews user={user}/>
                    </Box>
                    <Box className={classes.sectionBox} ref={programNewsRef}>
                        <SchoolProgramNews user={user}/>
                    </Box>
                </Container>
            </Box>
            <Box className={classes.sectionBox}>
                <CTADashboard />
            </Box>
        </>
    )
}

export default SchoolIndexView
